
import { API_URL, STATIC_URL, CALL_IOS_APP_DEEPLINK, ANDROID_URL_SCHEME,TRACKIDS } from './constants';
import {  DEFAULT_AVATAR, PLACEHOLDER_IMG, PLAY_BUTTON } from "./img-constant";

export const getEnv = () => {
  let env = 'mock';
  const host = location.host;
   if (/dev\.|\d+\.\d+\.|localhost/.test(host)) {
    env = 'dev';
  } else if (/\.qa\./.test(host)) {
    env = 'qa';
  } else if (/\.pre\./.test(host)) {
    env = 'pre';
  } else {
    env = 'pro';
   }
  
  if (top.location.origin.indexOf('static.91jkys.com')>-1) {
    env='pro'
  }

  return env;
};

export const getAppDownloadUrl = deeplinkUrl => {
  let url = '';
  const queryString = deeplinkUrl ? `?url=${escape(deeplinkUrl)}` : '';
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/.test(ua)) {
    url = CALL_IOS_APP_DEEPLINK[env] + queryString;
  } else {
    url = ANDROID_URL_SCHEME + queryString;
  }

  console.log('getAppDownloadUrl', url);

  return url;
};

export const env = getEnv();

export const iosDeeplink = CALL_IOS_APP_DEEPLINK[env];

export const apiUrl = API_URL[env];

export const staticUrl = STATIC_URL[env];

export const defaultAvatar = DEFAULT_AVATAR 
export const placeholderImg = PLACEHOLDER_IMG 

export const playButton = PLAY_BUTTON

export const trackIds = TRACKIDS


